import React from 'react';
import { INK } from '../styles';

interface Props {
  children: React.ReactNode;
}

export default function BoxLabel({ children }: Props) {
  return (
    <div style={{
      fontSize: 10,
      color: INK,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.4px',
      marginBottom: 6,
    }}>
      {children}
    </div>
  );
}